import axios from 'axios'

const api = axios.create({
  baseURL: "https://d-road.dromii.com", // 환경변수에서 baseURL을 가져옴
})

// 비밀번호 찾기 이메일 발송
export const sendPasswordResetEmail = async (data) => {
  try {
    const res = await api.post('/api/forgot-password', data); // 백엔드 경로에 맞게 수정
    return res.data;
  } catch (error) {
    console.error("Error sending password reset email:", error);
    throw error;
  }
};

// 회원가입
export const registerUser = async (userData) => {
  try {
    const res = await api.post('/api/register', userData);
    return res.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
}

// 이메일 인증 요청 
export const sendVerificationCode = async (data) => {
  try {
    const res = await api.post('/api/send-verification', data);
    return res.data;
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
}

//이메일 인증 확인
export const verifyEmailCode = async (data) => {
  try {
    const res = await api.post('/api/verify-code', data);
    return res.data;
  } catch (error) {
    console.error("Error verifying email code:", error);
    throw error;
  }
}

// userId 중복 확인 API
export const checkUserIdDuplicate = async (userId) => {
  try {
    const res = await api.post('/api/check-userid', { userId });
    console.log('api checkUserIdDuplicate 결과:', res.data)
    return res.data;  // 예: { isDuplicate: true } 또는 { isDuplicate: false }
  } catch (error) {
    console.error("Error checking userId duplicate:", error);
    throw error;
  }
};


